import { Permission } from "@eview/core/auth/permission"
import { FormGrantAction, GlobalCapability } from "@eview/core/auth/form-grants"

export const NavData = [
  {
    label: '2018 - 2022',
    route: '/dashboard/map/mace',
    isActive: true,
    description: 'Showing From 2018 - 2022',
    slug: 'past_records'
  },
  {
    label: '2023 -',
    route: '/dashboard/map',
    isActive: false,
    description: 'Showing Latest Reports (2023 - )',
    slug: 'latest'
  }
]
export const ViewData = [
  {
    label: 'MENU_MAP_VIEW',
    activeForRoutes: ['/dashboard/map', '/dashboard/map/mace'],
    route: '/dashboard/map/mace',
    isActive: true
  },
  {
    label: 'MENU_LIST_VIEW',
    activeForRoutes: ['/dashboard/posts', '/dashboard/posts/mace'],
    route: '/dashboard/posts/mace',
    isActive: false
  }
]

export interface RoutePermission {
  path: string;
  permission?: Permission;
  global?: string;
  formId?: number | null;
  formAction?: FormGrantAction;
}

/** Route access based on form grants + global capabilities only. */
export const routePermissions: RoutePermission[] = [
  {
    path: '/dashboard/posts/mace',
    formAction: 'view',
    formId: null
  },
  {
    path: '/dashboard/posts/analysis',
    formAction: 'analysis',
    formId: null
  },
  {
    path: '/dashboard/posts/resumen',
    formAction: 'analysis',
    formId: null
  },
  {
    path: '/dashboard/analysis',
    formAction: 'analysis',
    formId: null
  },
  {
    path: '/dashboard/analysis-templates',
    formAction: 'analysis',
    formId: null
  },
  {
    path: '/dashboard/settings/user-access-management',
    global: GlobalCapability.RolesManage
  },
  {
    path: '/dashboard/settings/user-management',
    global: GlobalCapability.UsersManage
  },
  {
    path: '/dashboard/categories/tags',
    global: GlobalCapability.TagsManage
  },
  {
    path: '/dashboard/categories/forms-management',
    global: GlobalCapability.FormsConfigure
  },
  {
    path: '/dashboard/tags',
    global: GlobalCapability.TagsManage
  },
  {
    path: '/dashboard/forms-management',
    global: GlobalCapability.FormsConfigure
  },
  {
    path: '/dashboard/user-access-management',
    global: GlobalCapability.RolesManage
  },
  {
    path: '/dashboard/user-management',
    global: GlobalCapability.UsersManage
  }
];
